/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * JUST7
 */
export type JUST7Enum = (typeof JUST7Enum)[keyof typeof JUST7Enum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JUST7Enum = {
  BP165: 'BP165',
  ARRHYTHMIA: 'ARRHYTHMIA',
  CONJUGATE_DEVIATION: 'CONJUGATE_DEVIATION',
  HEADACHE: 'HEADACHE',
  DYSARTHRIA: 'DYSARTHRIA',
  DISTURBANCE_OF_CONSCIOUSNESS: 'DISTURBANCE_OF_CONSCIOUSNESS',
  UPPER_LIMB_PARALYSIS: 'UPPER_LIMB_PARALYSIS',
} as const;
